/**
 * Resolve the Pool/website domain used for config and content fetch.
 *
 * Prefer the merged explicit domain (URL `?kz_domain=` wins over init /
 * script attrs). Otherwise use the page hostname.
 *
 * Pool website lookups do not accept a leading `www.` host label.
 */

export function normalizePoolDomain(domain: string): string {
  const trimmed = domain.trim();
  if (/^www\./i.test(trimmed)) return trimmed.slice(4);
  return trimmed;
}

export function resolveInitDomain(
  explicitDomain: string | undefined,
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): string {
  const trimmed = explicitDomain?.trim();
  return normalizePoolDomain(trimmed || hostname);
}
